import {ApplicationRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {PedidoLoja} from "../../objeto/PedidoLoja";
import {DadosCartao} from "../../objeto/DadosCartao";
import {ICartaoCreditoGateway} from "../../objeto/ICartaoCreditoGateway";
import {CadCartaoPadrao} from "../../objeto/CadCartaoPadrao";
import {AutorizacaoLojaService} from "../../services/autorizacao-loja.service";
import {CellcoinCartaoTokenizacaoService} from "../../services/cellcoin-cartao-tokenizacao.service";

@Component({
  selector: 'app-cad-cartao-cellcoin',
  templateUrl: './cad-cartao-cellcoin.component.html',
  styleUrls: ['../cad-cartao-tunapay/cad-cartao-tunapay.component.scss']
})
export class CadCartaoCellcoinComponent implements OnInit, ICartaoCreditoGateway {
  @Input() pedido: PedidoLoja;
  @ViewChild('formCartao') formCartao: NgForm;
  @ViewChild('formCartao', { read: ElementRef }) public frmElement: ElementRef;
  cartao: any = new DadosCartao();
  erroCartao: string;
  erroInicializacao: string;
  carregando = true;

  constructor(public app: ApplicationRef,
              private cadCartaoPadrao: CadCartaoPadrao,
              private autorizacaoService: AutorizacaoLojaService,
              private cellcoinTokenizacao: CellcoinCartaoTokenizacaoService) {
  }

  ngOnInit() {
    const usuario = this.autorizacaoService.getUsuario();

    if(usuario && usuario.cpf) this.cartao.cpf = usuario.cpf;
    if(usuario && usuario.email) this.cartao.email = usuario.email;
    if(!this.cartao.nome) this.cartao.nome = '';
    if(!this.cartao.cpf) this.cartao.cpf = '';

    this.inicializeCellcoin();
  }

  ehValido(): any {
    return this.cadCartaoPadrao.ehValido(this.formCartao, this.frmElement);
  }

  exibaCartao(dadosCartao: DadosCartao) {
    if(dadosCartao) {
      this.cartao = new DadosCartao();
      Object.assign(this.cartao, dadosCartao);
    }
  }

  async crieTokenCartao(endereco: any): Promise<DadosCartao> {
    return new Promise(async (resolve, reject) => {
      try {
        this.erroCartao = null;

        const validade = new Date(this.cartao.validade);
        const mes = String(validade.getMonth() + 1).padStart(2, '0');
        const ano = validade.getFullYear();
        const numero = String(this.cartao.numero || '').replace(/\D/g, '');
        const tokenizacao = await this.cellcoinTokenizacao.tokenize({
          number: numero,
          holder: this.cartao.nome,
          expiresAt: `${ano}-${mes}`,
          cvv: this.cartao.cvv
        });

        this.cartao.token = tokenizacao.token;
        this.cartao.cryptData = tokenizacao.cryptData;
        this.cartao.tokenize = tokenizacao.tokenize;
        this.cartao.ultimosNumeros = tokenizacao.ultimosNumeros;
        this.cartao.bandeira = tokenizacao.bandeira ;
        this.cartao.descricaoPagamento = `${this.cartao.bandeira.toUpperCase().trim()} *** ${this.cartao.ultimosNumeros}`;

        resolve(this.cartao);
      } catch (erro) {
        this.erroCartao = erro.message || 'Erro ao processar cartão Cellcoin';
        reject(this.erroCartao);
      }
    });
  }

  private async inicializeCellcoin() {
    try {
      await this.cellcoinTokenizacao.inicialize();
      this.carregando = false;
    } catch (erro) {
      this.carregando = false;
      this.erroInicializacao = erro.message || 'Não foi possível iniciar pagamento Cellcoin.';
    }
  }
}
